// show/hide navbar or mobile
$('.toggle-visibility').on('click tap', function () {
  $('.sideNav').toggleClass('showNav')
  $('.closeNav').toggleClass('active')
})

// Nav logo animation
$('.toggle-visibility, .nav-item__menu-item').on('click tap', function () {
  $('#navlogo').toggleClass('is-active')
})

// Hamburger menu animation
$('.hamburger').click(function () {
  $(this).toggleClass('is-active')
})

// Keep sidenav open on submenu clicks
$('.nav-item__submenu-item').on('click tap', function () {
  $('#sideNav').removeClass('showNav')
  $('.toggle-visibility').removeClass('is-active')
  $('.closeNav').toggleClass('active')
})

$('.nav-item__menu-item').on('click tap', function () {
  $('#sideNav').removeClass('showNav')
  $('.toggle-visibility').removeClass('is-active')
  $('.closeNav').toggleClass('active')
})

// Click off menu close
$('.closeNav').on('click', function () {
  $('.sideNav').removeClass('showNav')
  $('.closeNav').toggleClass('active')
  $('.hamburger').toggleClass('is-active')
})



// WEBPACK FOOTER //
// ./src/assets/js/_hamburger.js